module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "title": "Resources by John Ortberg"
    }
  }, [_c('h1', {
    staticClass: "resource_h"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_2",
      "title": "2"
    }
  }, [_vm._v("Resources by John Ortberg")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('i', [_vm._v("Everybody’s Normal Till You Get to Know Them")])]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_vm._v("(book, ebook, audio)")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('i', [_vm._v("God Is Closer Than You Think")])]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_vm._v("(book, ebook, audio, curriculum with Stephen and Amanda Sorenson)")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('i', [_vm._v("If You Want to Walk on Water, You’ve Got to Get Out of the Boat")])]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_vm._v("(book, ebook, audio, curriculum with Stephen and Amanda Sorenson)")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('i', [_vm._v("Know Doubt")])]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_vm._v("(book, ebook, previously titled Faith and Doubt)")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('i', [_vm._v("The Life You’ve Always Wanted")])]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_vm._v("(book, ebook, audio, curriculum with Stephen and Amanda Sorenson)")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('i', [_vm._v("Love Beyond Reason")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('i', [_vm._v("The Me I Want to Be")])]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_vm._v("(book, ebook, audio, curriculum with Scott Rubin)")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('i', [_vm._v("Soul Keeping")])]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_vm._v("(book, ebook, curriculum with Christine M. Anderson)")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('i', [_vm._v("When the Game Is Over, It All Goes Back in the Box")])]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_vm._v("(book, ebook, audio, curriculum with Stephen and Amanda Sorenson)")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('i', [_vm._v("Who Is This Man?")])]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_vm._v("(book, ebook, audio, curriculum with Christine M. Anderson)")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-68859692","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780310296065_Resources.vue
// module id = 60
// module chunks = 0